// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7a7954de","239":"9e999eb7","455":"529b0233"}[chunkId] + ".chunk.js";
};